import React, { FC, useEffect, useState } from "react";
import { useCountryStore } from "../../store/useCountryStore";
import { useAccountStore } from "../../store/useAccountStore";

interface CompanySelectProps {
  country?: string;
}
const companies = [
  {
    label: "Bangladesh-Pureit",
    value: "pureit-bangladesh",
    flag: "assets/bangladesh-flag.svg",
    company: "pureit",
    country: "BD",
    domain:'@aosmith.com'
  },
  {
    label: "India-AOSmith",
    value: "aosmith-india",
    flag: "assets/india-flag.svg",
    company: "aosmith",
    country: "IN",
        domain:'@aosmithindia.com'
  },

  {
    label: "India-Pureit",
    value: "pureit-india",
    flag: "assets/india-flag.svg",
    company: "pureit",
    country: "IN",
        domain:'@aosmith.com'
  },

  {
    label: "Sri Lanka-Pureit",
    value: "pureit-srilanka",
    flag: "assets/srilanka-flag.svg",
    company: "pureit",
    country: "LK",
     domain:'@aosmith.com'
  },
];
const CompanySelect: FC<CompanySelectProps> = () => {

    const {user}= useAccountStore();
    const [selectedCompany, setselectedCompany] = useState<any>({})
  // Sync prop -> store (only when prop exists)
  useEffect(() => {
    if (user) {
      const found = companies.find(c => c.value === user?.company);
      if (found) setselectedCompany(found);
    }
  }, [user]);

  return (
    <div className="flex flex-wrap gap-2 ">
      {[selectedCompany].map(item => {
        const isActive =true

        return (
          <div
            key={item?.label}
            // onClick={() => setselectedCompany(item)}
            className={`
              cursor-pointer group relative
              h-10 lg:h-12 px-4 flex items-center gap-2
              rounded-lg transition-all duration-300
              border-b-2 shadow-md
              ${
                isActive
                  ? "border-green-600 bg-green-50 shadow-green-200"
                  : "border-gray-200 bg-white"
              }
            `}
          >
            {/* Flag */}
            <div className="w-6 h-4 lg:w-8 lg:h-6 rounded overflow-hidden">
              <img
                src={item.flag}
                alt={item.name}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Name */}
            <span
              className={`text-xs lg:text-sm font-medium ${
                isActive ? "text-green-700" : "text-gray-600"
              }`}
            >
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default CompanySelect;
